export default "__VITE_PUBLIC_ASSET__33a1065a__"